import { ModuleWithProviders, NgModule, ErrorHandler, Optional, SkipSelf } from '@angular/core';
import { GlobalErrorHandler } from "./global-error-handler";
import { HttpErrorInterceptor } from "./http-error.interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

@NgModule({
  providers: [
    ErrorHandler,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
  ]
})

export class ErrorHandlerModule {
  static forRoot(): ModuleWithProviders<ErrorHandlerModule> {
    return {
      ngModule: ErrorHandlerModule,
      providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ErrorHandlerModule) {
    if (parentModule) {
      throw new Error('ErrorHandlerModule is already loaded. Import it in the CoreModule only');
    }
  }
}
